import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const apiGetRegisteredCompanies = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunction(data,apiConstants.COMPANIES.GET_REGISTERED_COMPANIES)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
